<template>
    <div>
        <StructuredData />
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--150" no-body>
                    <div class="px-4 py-5">
                        <div class="text-center mb-5">
                            <h1 class="display-3">WordPress Entwicklung</h1>
                            <p class="lead">
                                Professionelle WordPress-Lösungen für Ihr Unternehmen im DACH-Raum
                            </p>
                        </div>

                        <div class="row">
                            <div class="col-lg-8 mx-auto">
                                <h2>Warum WordPress?</h2>
                                <p>
                                    WordPress ist das weltweit beliebteste Content Management System und das nicht ohne Grund. 
                                    Über 43% aller Webseiten weltweit nutzen WordPress. Es ist benutzerfreundlich, flexibel 
                                    und bietet unendliche Möglichkeiten für Ihr Unternehmen.
                                </p>

                                <h3 class="mt-5">Unsere WordPress-Leistungen</h3>
                                
                                <div class="row mt-4">
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-primary">
                                                    <icon name="fa fa-wordpress" class="mr-2"></icon>
                                                    WordPress Webseiten
                                                </h5>
                                                <p>
                                                    Maßgeschneiderte WordPress-Webseiten, die perfekt auf Ihre 
                                                    Anforderungen zugeschnitten sind. Von der Konzeption bis zum Launch.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-success">
                                                    <icon name="ni ni-settings-gear-65" class="mr-2"></icon>
                                                    Plugin-Entwicklung
                                                </h5>
                                                <p>
                                                    Individuelle WordPress-Plugins für spezielle Anforderungen. 
                                                    Erweitern Sie WordPress genau nach Ihren Wünschen.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-warning">
                                                    <icon name="ni ni-palette" class="mr-2"></icon>
                                                    Theme-Entwicklung
                                                </h5>
                                                <p>
                                                    Einzigartige WordPress-Themes, die Ihre Marke perfekt repräsentieren. 
                                                    Responsive, schnell und SEO-optimiert.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-info">
                                                    <icon name="ni ni-chart-bar-32" class="mr-2"></icon>
                                                    Performance-Optimierung
                                                </h5>
                                                <p>
                                                    Schnellere Ladezeiten, bessere Rankings. Wir optimieren Ihre 
                                                    WordPress-Seite für maximale Performance.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                </div>

                                <h3 class="mt-5">Technologien & Best Practices</h3>
                                <div class="mt-3">
                                    <badge type="primary" rounded class="mr-2 mb-2">WordPress 6.x</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">WooCommerce</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Gutenberg</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">ACF Pro</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">REST API</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Custom Post Types</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Multisite</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Security Hardening</badge>
                                </div>

                                <h3 class="mt-5">Warum Web Services and More?</h3>
                                <ul class="list-unstyled mt-3">
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Über 15 Jahre WordPress-Erfahrung
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Hunderte erfolgreiche WordPress-Projekte
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Expertise in Performance & Security
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        Wartung & Support nach dem Launch
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        SEO-optimierte Entwicklung
                                    </li>
                                </ul>

                                <div class="text-center mt-5">
                                    <base-button
                                        tag="a"
                                        href="/#kontakt"
                                        type="primary"
                                        size="lg"
                                        icon="fa fa-envelope"
                                        @click.prevent="$router.push('/#kontakt')"
                                    >
                                        Jetzt WordPress-Projekt anfragen
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
import StructuredData from '../components/StructuredData.vue'

export default {
    name: 'wordpress',
    components: {
        StructuredData
    },
    head: {
        title: {
            inner: 'WordPress Entwicklung DACH',
            separator: '|',
            complement: 'Web Services and More'
        },
        meta: [
            {
                name: 'description',
                content: 'WordPress Agentur DACH ✓ Custom Theme & Plugin Entwicklung ✓ WooCommerce Shops ✓ Performance-Optimierung ✓ Wartung & Support ✓ 15+ Jahre Erfahrung ✓ Jetzt anfragen!',
                id: 'desc'
            },
            {
                name: 'keywords',
                content: 'WordPress Entwicklung, WordPress Agentur, WordPress Theme Entwicklung, WordPress Plugin Entwicklung, WooCommerce, WordPress Performance, WordPress Wartung, WordPress DACH, WordPress Deutschland'
            },
            {
                property: 'og:title',
                content: 'WordPress Entwicklung DACH | Web Services and More'
            },
            {
                property: 'og:description',
                content: 'WordPress Agentur im DACH-Raum. Custom Theme & Plugin Entwicklung, WooCommerce Shops, Performance-Optimierung. 15+ Jahre Erfahrung.'
            },
            {
                property: 'og:type',
                content: 'website'
            },
            {
                property: 'og:url',
                content: 'https://www.wsam.biz/wordpress'
            },
            {
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                name: 'twitter:title',
                content: 'WordPress Entwicklung DACH | Web Services and More'
            },
            {
                name: 'twitter:description',
                content: 'WordPress Agentur im DACH-Raum. Custom Theme & Plugin Entwicklung, WooCommerce Shops, Performance-Optimierung.'
            }
        ]
    }
}
</script>
